import config from '../config'
import { Auth } from '@aws-amplify/auth'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Query: {
        dashboard: async (_, args) => {
            const session = await Auth.currentSession();
            console.log('args', args);
            if (Array.isArray(args?.summary)){
                for (const summary of args.summary){
                    if (typeof summary.map_group_value === "string"){
                        try {
                            summary.map_group_value = JSON.parse(summary.map_group_value);
                        }
                        catch (error) {
                            console.error('Error parsing map_group_value for summary', summary.label, error);
                            summary.map_group_value = null;
                        }
                    }
                }
            }
            const response = await fetch(config.dashboardAPI + '/dashboard', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': session.idToken.jwtToken
                },
                body: JSON.stringify(args)
            });
            const respData = await response;
            if (respData.ok){
                return respData.json();
            }
            else{
                var json;
                try{
                    json = await respData.json();
                }
                catch(e){}
                const message = json ? json.Message : await respData.text();
                const error = Error(message);
                error.name = json ? json.Code : 'Error';
                console.error(error);
                throw error
            }
        }
    }
}